export default {"src":"/_next/static/media/open.02bbff71.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};